import Maxens from "../assets/img/trombinoscope/Maxens.jpg";
import Milo from "../assets/img/trombinoscope/Milo.jpg";
import Pilar from "../assets/img/trombinoscope/Pilar.jpg";
import Hermione from "../assets/img/trombinoscope/Hermione.jpg";
import Nina from "../assets/img/trombinoscope/Nina.jpg";
import Gwen from "../assets/img/trombinoscope/Gwen.jpg";
import Pierre from "../assets/img/trombinoscope/Pierre.jpg";
import Gabriel from "../assets/img/trombinoscope/Gabriel.jpg";
import Baptiste from "../assets/img/trombinoscope/Baptiste.jpg";
import Julie from "../assets/img/trombinoscope/Julie.jpg";
import Coline from "../assets/img/trombinoscope/Coline.jpg";
import Théophane from "../assets/img/trombinoscope/Théophane.jpg";
import Orane from "../assets/img/trombinoscope/Orane.jpg";
import Robin from "../assets/img/trombinoscope/Robin.jpg";
import Maxence from "../assets/img/trombinoscope/Maxence.jpg";

const members = [
  {
    name: "Milo",
    role: "Président",
    image: Milo,
  },
  {
    name: "Maxens",
    role: "Secrétaire",
    image: Maxens,
  },
  {
    name: "Pilar",
    role: "Trésorière",
    image: Pilar,
  },
  {
    name: "Hermione",
    role: "Fouaille",
    image: Hermione,
  },
  {
    name: "Nina",
    role: "Fouaille",
    image: Nina,
  },
  {
    name: "Gwen",
    role: "Fouaille",
    image: Gwen,
  },
  {
    name: "Pierre",
    role: "Fouaille",
    image: Pierre,
  },
  {
    name: "Gabriel",
    role: "Int",
    image: Gabriel,
  },
  {
    name: "Baptiste",
    role: "Alternance",
    image: Baptiste,
  },
  {
    name: "Julie",
    role: "Réseaux",
    image: Julie,
  },
  {
    name: "Coline",
    role: "Tech",
    image: Coline,
  },

  {
    name: "Théophane",
    role: "Spons",
    image: Théophane,
  },
  {
    name: "Orane",
    role: "Spons",
    image: Orane,
  },

  {
    name: "Robin",
    role: "Ext",
    image: Robin,
  },
  {
    name: "Maxence",
    role: "Ext",
    image: Maxence,
  },
];

export default members;
